export default "__VITE_PUBLIC_ASSET__1b230fda__"